import React from 'react';
import { useLogoutContext } from 'Context/LogoutContext';
import { InvestmentsNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Investments';
import { FoundationsNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Foundations';
import { HomeNavButton } from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/Home';
import {
  ReferralPageNavButton,
} from 'Components/ClientApp/CombinedApp/Navigation/HydratedNavButtons/ReferralPageNavButton';
import { NavButton } from '../NavButton';
import { ProfileNavButton } from '../HydratedNavButtons/Profile';

export const DrawerClientNavFoundationalOnly = () => {
  const { logout } = useLogoutContext();
  return (
    <>
      <HomeNavButton />
      <FoundationsNavButton />
      <InvestmentsNavButton />
      <ReferralPageNavButton />
      <ProfileNavButton hideAvatar />
      <NavButton value="logout" onClick={logout} label="Logout" />
    </>
  );
};
